
import { SubscriptionsPanel } from "@/components/subscriptions";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Subscriptions",
  components: { SubscriptionsPanel },
});
